<script>
import Message from './Message.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { Message, NextButton },
  data() {
    return {
      link: import.meta.env
        .VITE_WIDGET_CONVERSATION_CONTACT_OFFLINE_MESSAGE_LINK,
    };
  },
};
</script>

<template>
  <div class="p-5 flex flex-col items-center">
    <Message>
      O cliente não esta mais online na página, você pode entrar em contato pelo
      whatsapp com ele.
    </Message>
    <a :href="link" target="_blank" rel="noopener nofollow noreferrer">
      <NextButton link blue class="p-0 text-base font-medium block">
        Veja aqui como fazer isso pela plataforma.
      </NextButton>
    </a>
  </div>
</template>
